const iframeId = 'attach-cart-iframe'
const iframeWrapperId = 'iframe-cart-holder'

let cartButton
let cartForm
let cartBrand

// Clear the iframe wrapper
const getAndClearIframeWrapper = () => {
  let wrapper = document.getElementById(iframeWrapperId)
  wrapper.innerHTML = ''

  return wrapper
}

const getAndAppendIframe = (wrapper) => {
  let iframe = document.createElement('iframe')
  iframe.id = iframeId
  iframe.name = iframeId
  iframe.className = iframeId
  iframe.style.width = '400px'
  iframe.style.height = '200px'
  iframe.style.display = 'none'
  wrapper.appendChild(iframe)

  return iframe
}

const getIframeBody = () => {
  let iframe = document.getElementById(iframeId)
  let doc = iframe.contentDocument || iframe.contentWindow.document

  return doc.body
}

const getIframeForm = (currentProduct) => {
  if (!currentProduct || !currentProduct.cartMetadata) return
  let form = document.createElement('form');
  form.action = currentProduct.cartMetadata.addToCartUrl
  form.target = iframeId
  form.method = 'POST'
  if (currentProduct && currentProduct.cartMetadata && currentProduct.cartMetadata.hiddenInputs) {
    currentProduct.cartMetadata.hiddenInputs.map((hiddenInput) => {
      let input = document.createElement('input')
      input.type = 'hidden'
      for (let key in hiddenInput) {
        input[key] = hiddenInput[key]
      }

      form.appendChild(input)
    })
  }

  let button = document.createElement('button')
  button.type = 'submit'
  form.appendChild(button)

  // Keep reference to button.
  cartButton = button
  cartForm = form

  return form
}

const checkIframeLoad = (utm, eventObject) => {
  let iframe = document.getElementById(iframeId)
  iframe.onload = () => {
    goToCart(utm, eventObject)
  }
}

const goToCart = (utm, eventObject) => {
  let cartUrl = cartBrand.cartLink
  setTimeout(() => {
    fireEventAndRedirect(`${cartUrl}${utm}`, eventObject)
  }, 500)
}

const fireEventAndRedirect = (url, eventObject) => {
  if (!amplitude) {
    let self = this
    setTimeout(() => {
      fireEventAndRedirect(url)
    }, 100)
    return
  }

  amplitude.getInstance().logEvent('CART_LOADED', eventObject, () => {
    window.location = url
  });
}

export default {
  createAndAppendFormToIframe(currentProduct, currentBrand, utm, eventObject) {
    cartBrand = currentBrand
    let wrapper = getAndClearIframeWrapper()
    let iframe = getAndAppendIframe(wrapper)

    let body = getIframeBody()
    let form = getIframeForm(currentProduct)

    body.appendChild(form)
    window.clearInterval(window.iframeCartTimeout)

    cartButton.click()
    checkIframeLoad(utm, eventObject)
  }
}



// WEBPACK FOOTER //
// ./client/lib/cartManager.js